import styled from 'styled-components'

export const Header = styled.div`
	display: flex;
	flex-direction: column;
	gap: 12px;
	margin-bottom: 24px;
`

export const Grid = styled.div`
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	gap: 16px;

	@media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
		grid-template-columns: 1fr;
	}
`

export const Card = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 16px;
	padding: 20px 24px;
	border: 1px solid ${props => props.theme.colors.greys.dividerGray};
	border-radius: 12px;
	background-color: ${props => props.theme.colors.brand.white};
	cursor: pointer;
	transition: box-shadow 0.2s, border-color 0.2s;

	&:hover {
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
		border-color: ${props => props.theme.colors.greys.cardHoverBorder};
	}
`

export const CardText = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2px;
`

export const ClinicCard = styled.div`
	display: flex;
	flex-direction: column;
	gap: 12px;
	padding: 20px 24px;
	border: 1px solid ${props => props.theme.colors.greys.dividerGray};
	border-radius: 12px;
	background-color: ${props => props.theme.colors.brand.white};
`

export const ClinicHeader = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
`

export const ClinicLogo = styled.img`
	width: 40px;
	height: 40px;
	border-radius: 50%;
	flex-shrink: 0;
	object-fit: cover;
`

export const ClinicInfo = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2px;
`

export const Schedule = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
`

